class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this.dialog = this.querySelector('dialog');
    this.closeButton = this.querySelector('.newsletter-popup__close');
    this.form = this.querySelector('form');
    
    this.delay = parseInt(this.dataset.delay, 10) * 1000 || 5000;
    this.expiryDays = parseInt(this.dataset.expiry, 10) || 7;
    this.testMode = this.dataset.testMode === 'true';
    
    this.init();
  }

  init() {
    if (this.shouldShowPopup()) {
      setTimeout(() => this.open(), this.delay);
    }

    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => this.close());
    }

    if (this.form) {
      this.form.addEventListener('submit', () => this.setDismissedState());
    }

    // Check if URL has customer_posted=true to show success state
    if (window.location.search.includes('customer_posted=true')) {
      this.setDismissedState();
    }
  }

  shouldShowPopup() {
    if (this.testMode) return true;

    const dismissedTime = localStorage.getItem('newsletter_popup_dismissed');
    if (!dismissedTime) return true;

    const now = new Date().getTime();
    const expiryTime = parseInt(dismissedTime, 10) + (this.expiryDays * 24 * 60 * 60 * 1000);
    
    return now > expiryTime;
  }

  setDismissedState() {
    localStorage.setItem('newsletter_popup_dismissed', new Date().getTime().toString());
  }

  open() {
    // If we're using a dialog element
    if (this.dialog && typeof this.dialog.show === 'function') {
      this.dialog.show();
    }
    this.dialog.setAttribute('open', '');
    
    // Add escape key listener
    document.addEventListener('keydown', this.onKeyDown.bind(this));
  }

  close() {
    this.setDismissedState();
    this.dialog.removeAttribute('open');
    if (this.dialog && typeof this.dialog.close === 'function') {
      setTimeout(() => this.dialog.close(), 400); // wait for transition
    }
    document.removeEventListener('keydown', this.onKeyDown.bind(this));
  }

  onKeyDown(event) {
    if (event.key === 'Escape') {
      this.close();
    }
  }
}

customElements.define('newsletter-popup', NewsletterPopup);
